/* Floating Flame dealer locator (sections/ff-dealers.liquid) */
(function () {
  // Site GTM fetch wrapper (snippets/shopify-datalayer.liquid) calls .includes() on every fetch arg; Mapbox passes Request objects
  if (typeof Request !== 'undefined' && !Request.prototype.includes) Request.prototype.includes = function (s) { return String(this.url).indexOf(s) > -1; };
  var PROV = ['AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'];
  var PAGE = 4;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hav(a, b) {
    var R = 3958.8, r = Math.PI / 180, dLa = (b[1] - a[1]) * r, dLo = (b[0] - a[0]) * r;
    var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a[1] * r) * Math.cos(b[1] * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function digits(p) { return String(p || '').replace(/ext.*$/i, '').replace(/[^\d+]/g, ''); }
  function href(u) { u = String(u || '').trim(); if (!u) return ''; return /^https?:\/\//i.test(u) ? u : 'https://' + u.replace(/^\/\//, ''); }

  function init(root) {
    var dataEl = root.querySelector('[data-ffd-data]');
    if (!dataEl) return;
    var raw = [];
    try { raw = JSON.parse(dataEl.textContent); } catch (e) { raw = []; }
    var token = root.getAttribute('data-token');
    var radius = parseFloat(root.getAttribute('data-radius')) || 100;
    var dealers = raw.map(function (d, i) {
      var st = String(d.s || '').trim().toUpperCase();
      var isCa = /canada/i.test(d.k || '') || PROV.indexOf(st) > -1;
      var lat = parseFloat(String(d.lat).trim()), lng = parseFloat(String(d.lng).trim());
      return { i: i, n: String(d.n || '').trim(), a: String(d.a || '').trim(), c: String(d.c || '').trim(), s: st, z: String(d.z || '').trim(),
        p: String(d.p || '').trim(), w: href(d.w), logo: d.logo || '', ca: isCa, ll: (isFinite(lat) && isFinite(lng)) ? [lng, lat] : null, dist: null };
    }).filter(function (d) { return d.n; });

    var els = {
      form: root.querySelector('[data-ffd-form]'), q: root.querySelector('[data-ffd-q]'), geo: root.querySelector('[data-ffd-geo]'),
      status: root.querySelector('[data-ffd-status]'), list: root.querySelector('[data-ffd-list]'), more: root.querySelector('[data-ffd-more]'),
      title: root.querySelector('[data-ffd-title]'), sub: root.querySelector('[data-ffd-sub]'), map: root.querySelector('[data-ffd-map]'),
      filters: [].slice.call(root.querySelectorAll('[data-ffd-filter]')), loc: root.querySelector('[data-ffd-loc]')
    };
    var st = { origin: null, label: '', km: false, filter: 'all', shown: PAGE, active: null, view: [] };

    // stats: counted live from the dealer list on every page load (Liquid renders the same numbers server-side)
    var states = {}, provs = {};
    dealers.forEach(function (d) { if (!d.s) return; (d.ca ? provs : states)[d.s] = 1; });
    function setStat(k, v) { var e = root.querySelector('[data-ffd-stat="' + k + '"]'); if (e) e.textContent = v; }
    setStat('total', dealers.length); setStat('states', Object.keys(states).length); setStat('provs', Object.keys(provs).length);

    function status(msg, err) { if (!els.status) return; els.status.textContent = msg || ''; els.status.classList.toggle('err', !!err); }
    function radLabel() { return st.km ? Math.round(radius * 1.609 / 50) * 50 + ' km' : radius + ' miles'; }
    function unit(mi) { return st.km ? Math.round(mi * 1.609) + ' km' : (mi < 10 ? mi.toFixed(1) : Math.round(mi)) + ' mi'; }

    function current() {
      var arr = dealers.filter(function (d) { return st.filter === 'all' || (st.filter === 'ca' ? d.ca : !d.ca); });
      if (st.origin) {
        arr.forEach(function (d) { d.dist = d.ll ? hav(st.origin, d.ll) : Infinity; });
        arr.sort(function (a, b) { return a.dist - b.dist; });
      } else {
        arr.forEach(function (d) { d.dist = null; });
        arr.sort(function (a, b) { return a.n.localeCompare(b.n); });
      }
      return arr;
    }

    function card(d, k) {
      var dest = encodeURIComponent([d.n, d.a, d.c, d.s, d.z].filter(Boolean).join(', '));
      var line2 = [d.c, [d.s, d.z].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      var h = '<li class="ffd-card' + (st.active === d.i ? ' active' : '') + '" data-i="' + d.i + '">';
      h += '<span class="num" aria-hidden="true">' + (k + 1) + '</span><div class="body"><div class="top">';
      h += '<h3><button type="button" data-ffd-show="' + d.i + '">' + esc(d.n) + '</button></h3>';
      if (d.dist != null && isFinite(d.dist)) h += '<span class="dist">' + unit(d.dist) + '</span>';
      h += '</div><p class="addr">' + esc(d.a) + (d.a && line2 ? '<br>' : '') + esc(line2) + '</p><div class="acts">';
      h += '<a class="chip on" href="https://www.google.com/maps/dir/?api=1&destination=' + dest + '" target="_blank" rel="noopener">Directions</a>';
      if (digits(d.p)) h += '<a class="chip" href="tel:' + digits(d.p) + '">' + esc(d.p) + '</a>';
      if (d.w) h += '<a class="chip" href="' + esc(d.w) + '" target="_blank" rel="noopener">Website</a>';
      h += '</div></div>';
      if (d.logo) h += '<img class="logo" src="' + esc(d.logo) + '" alt="" loading="lazy" width="64" height="40">';
      return h + '</li>';
    }

    function render() {
      var arr = current();
      var near = st.origin ? arr.filter(function (d) { return d.dist <= radius; }) : arr;
      var where = st.filter === 'ca' ? ' in Canada' : st.filter === 'us' ? ' in the US' : '';
      if (!st.origin) {
        els.title.textContent = 'All ' + arr.length + ' dealers' + where;
        els.sub.textContent = 'Enter your ZIP or postal code to see the closest.';
      } else if (near.length) {
        els.title.textContent = near.length + (near.length === 1 ? ' dealer' : ' dealers') + ' within ' + radLabel();
        els.sub.textContent = 'Call ahead to see a unit lit and in action.';
      } else {
        els.title.textContent = 'Nearest dealers' + where;
        els.sub.textContent = 'None within ' + radLabel() + ' of ' + st.label + '. Here are the closest, or see the options below.';
      }
      var show = arr.slice(0, st.shown);
      st.view = show;
      els.list.innerHTML = show.length ? show.map(card).join('') : '<li class="ffd-empty">No dealers match. Try All.</li>';
      if (els.more) {
        var left = arr.length - show.length;
        els.more.hidden = left <= 0;
        els.more.textContent = 'Show ' + Math.min(left, PAGE) + ' More';
      }
      paint();
    }

    // map
    var map = null, markers = {}, meMarker = null;
    function paint() {
      if (!map) return;
      var order = {};
      st.view.forEach(function (d, k) { order[d.i] = k + 1; });
      dealers.forEach(function (d) {
        var m = markers[d.i]; if (!m) return;
        var el = m.getElement(), n = order[d.i];
        var vis = st.filter === 'all' || (st.filter === 'ca' ? d.ca : !d.ca);
        // classList only: replacing className drops Mapbox's "mapboxgl-marker" class, which un-positions every pin after the first
        el.style.display = vis ? '' : 'none';
        el.classList.toggle('dot', !n);
        el.classList.toggle('active', st.active === d.i);
        el.style.zIndex = st.active === d.i ? '3' : (n ? '2' : '1');
        el.textContent = n ? String(n) : '';
        el.setAttribute('aria-label', d.n + (n ? ', result ' + n : ''));
      });
      if (st.origin) {
        if (!meMarker) { var me = document.createElement('div'); me.className = 'ffd-me'; meMarker = new mapboxgl.Marker(me); }
        meMarker.setLngLat(st.origin).addTo(map);
      } else if (meMarker) { meMarker.remove(); }
    }
    function fit() {
      if (!map) return;
      var pts = [];
      if (st.origin) { pts.push(st.origin); st.view.slice(0, 6).forEach(function (d) { if (d.ll && d.dist < 1500) pts.push(d.ll); }); }
      else { current().forEach(function (d) { if (d.ll && d.ll[1] < 58) pts.push(d.ll); }); }
      if (!pts.length) return;
      var b = new mapboxgl.LngLatBounds(pts[0], pts[0]);
      pts.forEach(function (p) { b.extend(p); });
      map.fitBounds(b, { padding: 50, maxZoom: 10, duration: 600 });
    }
    function select(i, fly) {
      st.active = i;
      [].forEach.call(els.list.querySelectorAll('.ffd-card'), function (c) { c.classList.toggle('active', +c.getAttribute('data-i') === i); });
      paint();
      var d = dealers.filter(function (x) { return x.i === i; })[0];
      if (d && map && d.ll && fly) map.flyTo({ center: d.ll, zoom: Math.max(map.getZoom(), 9), duration: 700 });
    }
    function startMap() {
      if (!els.map || !window.mapboxgl || !token) { if (els.map) els.map.parentNode.setAttribute('data-nomap', ''); return; }
      mapboxgl.accessToken = token;
      try {
        map = new mapboxgl.Map({ container: els.map, style: 'mapbox://styles/mapbox/light-v10', center: [-90, 44], zoom: 3.4, cooperativeGestures: true });
      } catch (e) { map = null; return; }
      map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
      dealers.forEach(function (d) {
        if (!d.ll) return;
        var el = document.createElement('button'); el.type = 'button'; el.className = 'ffd-pin dot';
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          var k = st.view.map(function (x) { return x.i; }).indexOf(d.i);
          if (k === -1) {
            // bring an off-list dealer into the list view
            var arr = current(); var pos = arr.map(function (x) { return x.i; }).indexOf(d.i);
            if (pos > -1) { st.shown = Math.max(st.shown, Math.ceil((pos + 1) / PAGE) * PAGE); render(); }
          }
          select(d.i, false);
          var c = els.list.querySelector('.ffd-card[data-i="' + d.i + '"]');
          if (c && window.matchMedia('(min-width:960px)').matches) c.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
        markers[d.i] = new mapboxgl.Marker(el).setLngLat(d.ll).addTo(map);
      });
      map.on('load', function () { paint(); fit(); });
    }

    // search
    function geocode(q) {
      var rev = /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(q);
      var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + (rev ? q : encodeURIComponent(q)) + '.json?' + (rev ? 'types=place' : 'country=us,ca&types=postcode,place,locality,region,address') + '&limit=1&access_token=' + token;
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('geo'); return r.json(); }).then(function (j) {
        var f = j && j.features && j.features[0]; if (!f) return null;
        var ctx = (f.context || []).concat([f]);
        var ca = ctx.some(function (c) { return /^country/.test(c.id) && /^ca$/i.test(c.short_code || ''); });
        return { ll: f.center, label: f.place_name.replace(/, (United States|Canada)$/, ''), ca: ca };
      });
    }
    function setOrigin(ll, label, ca) {
      st.origin = ll; st.label = label; st.km = !!ca; st.shown = PAGE; st.active = null;
      render();
      if (st.view[0]) select(st.view[0].i, false);
      fit();
      if (els.loc && els.loc.getBoundingClientRect().top > window.innerHeight * 0.6) els.loc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function search(q) {
      q = String(q || '').trim();
      if (!q) { status('Enter a ZIP or postal code, or a city.', true); els.q && els.q.focus(); return; }
      status('Searching…');
      geocode(q).then(function (g) {
        if (!g) { status('We couldn’t find "' + q + '". Try a 5-digit ZIP or a postal code like M5V 2T6.', true); return; }
        status('');
        setOrigin(g.ll, g.label, g.ca);
        try { var u = new URL(location.href); u.searchParams.set('q', q); history.replaceState(null, '', u); } catch (e) {}
      }).catch(function () { status('Search is unavailable right now. Browse the full list below.', true); });
    }
    if (els.form) els.form.addEventListener('submit', function (e) { e.preventDefault(); search(els.q.value); });
    if (els.geo) {
      if (!navigator.geolocation) els.geo.hidden = true;
      els.geo.addEventListener('click', function () {
        status('Finding your location…');
        navigator.geolocation.getCurrentPosition(function (p) {
          status('');
          var ll = [p.coords.longitude, p.coords.latitude];
          geocode(ll[0].toFixed(5) + ',' + ll[1].toFixed(5)).then(function (g) {
            setOrigin(ll, g ? 'your location (' + g.label.split(',').slice(0, 2).join(',') + ')' : 'your location', g && g.ca);
          }).catch(function () { setOrigin(ll, 'your location', false); });
        }, function () { status('We couldn’t get your location. Enter a ZIP or postal code instead.', true); }, { timeout: 10000, maximumAge: 600000 });
      });
    }
    els.filters.forEach(function (b) {
      b.addEventListener('click', function () {
        st.filter = b.getAttribute('data-ffd-filter'); st.shown = PAGE; st.active = null;
        els.filters.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        render(); fit();
      });
    });
    if (els.more) els.more.addEventListener('click', function () { st.shown += PAGE; render(); });
    // the whole card shows the dealer on the map; its Directions / phone / Website links keep working as links
    els.list.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var c = e.target.closest('.ffd-card'); if (!c) return;
      select(+c.getAttribute('data-i'), true);
      if (els.map && !window.matchMedia('(min-width:960px)').matches) els.map.parentNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    render();
    startMap();
    var q0 = null; try { q0 = new URL(location.href).searchParams.get('q'); } catch (e) {}
    if (q0) { els.q.value = q0; search(q0); }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-ffd]'), function (r) { if (!r.__ffd) { r.__ffd = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  // contact-form success: show the thank-you only on the form that was sent
  function forms() {
    if (!/contact_posted=true/.test(location.search)) return;
    var h = location.hash.replace('#', '');
    [].forEach.call(document.querySelectorAll('[data-ffd-ok]'), function (ok) {
      var f = ok.closest('form');
      if (f && (f.id === h || (!h && f.id === 'dealer-request'))) {
        ok.hidden = false;
        var d = f.closest('details'); if (d) d.open = true;
        f.querySelectorAll('.field,button[type=submit]').forEach(function (x) { x.hidden = true; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forms); else forms();
})();
